import { StockStatus } from "@/enums/StockStatus";
import { PriceType } from "@/enums/PriceType";
import { IIndexTile } from "@/models/IIndexTile";

export interface ProductList {
  pageNumber: number;
  numberOfPages: number;
  productCount: number;
  pageSize: number;
  products: ProductTile[];
}

export interface ProductImage {
  url: string;
  alt: string;
  width: number;
  height: number;
}

export interface ProductTile extends IIndexTile {
  name: string;
  price: string;
  priceIncVat: string;
  originalPrice: string;
  originalPriceIncVat: string;
  hasQuantityBreaks: boolean;
  hasVariants: boolean;
  callForPrice: boolean;
  hasFiles: boolean;
  url: string;
  imageUrl: ProductImage;
  sku: string;
  numberOfVariants: number;
  hasDwgs: boolean;
  hasDwg2dFiles: boolean;
  hasDwg3dFiles: boolean;
  dwgDownloadUrl: string;
  stock?: number;
  selector: VariantSelector;
  campaign: ProductCampaign;
  hoverImageUrl: ProductImage;
  stockStatus: StockStatus;
  new: boolean;
  priceType: PriceType;
  requestForFileFormId: string;
  requestForPriceFormId: string;
  discountPercent: number;
  isFavorited: boolean;
  isExternal: boolean;
  fastDelivery: boolean;
}

export enum VariantSelector {
  Color = "Color",
  Size = "Size",
  Hardness = "Hardness",
  Variant = "Variant",
}

export enum VariantSelectorAsNumber {
  Color,
  Size,
  Hardness,
  Variant,
}

export enum CampaignType {
  Standard = "Standard",
  Agreement = "Agreement",
}

export interface ProductPromotion {
  header: string;
  appliedAmount?: number;
  appliedAmountIncVat?: number;
}

export interface ProductQuantityBreak {
  qtyBreak: number;
  value: number;
  valueIncVat: number;
  isBuyable: boolean;
}

export interface ProductCampaign {
  name: string;
  type: CampaignType;
}

export interface ProductFilter {
  type: string;
  name: string;
  items: ProductFilterItem[];
}

export interface ProductFilterItem {
  id: string;
  name: string;
  value: string;
  type: string;
  count: number;
  selected?: boolean;
  items: ProductFilterItem[];
}

export interface ProductFilterMap {
  type: string;
  name: string;
  options: ProductFilterMapItem[];
}

export interface ProductFilterMapItem {
  id: string;
  type: string;
  name: string;
}
